import Icon from "./Icon";

export default function CustomMarker ({id, icon, img, name, type}) {
	return (
		<>
			<div className={`${type}-marker-container`} id={id}>
				<div className={`${type}-marker`}>
					{ icon && <Icon className="room-marker-icon" component={icon}/>}
					{ img && <img className="room-marker-img" src={img}/>}
				</div>
				{ name && <span className="room-marker-name">{ name }</span>}
			</div>
		</>
	)
}